import React from "react";
import './_static/StatusBar.css';
import logoutImage from './_images/person-fill-slash.svg';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {getAppName, useAxiosSetup} from "./Api";
import {useAppData} from "./AppDataContext";
import popupInfo from "./dialogs/PopupInfo";
import {useModal} from "./dialogs/ModalContext";

function StatusBar(props) {

    const {appData, updateAppData} = useAppData();
    const {showModal} = useModal();
    const api = useAxiosSetup();

    function logout() {
        const appName = getAppName()
        localStorage.setItem(`${appName}_access`, '')
        localStorage.setItem(`${appName}_refresh`, '')
        window.location.reload()
    }

    function getVersion() {
        const buildMeta = appData.buildInfo;
        const buildMetaJSON = buildMeta ? JSON.parse(buildMeta) : null;
        const screenWidth = window.innerWidth;
        if (screenWidth < 768) {
            if (buildMetaJSON) {
                return buildMetaJSON.BuildInfo.applicationversion
            } else {
                return null;
            }
        } else {
            if (buildMetaJSON) {
                return buildMetaJSON.BuildInfo.applicationversion + ':' + buildMetaJSON.BuildInfo.buildtime
            } else {
                return null;
            }
        }
    }

    React.useEffect(() => {
            if (appData.buildInfo) {
                if (appData.userVersionUpToDate === false) {
                    const buildMeta = appData.buildInfo;
                    const buildMetaJSON = buildMeta ? JSON.parse(buildMeta) : null;
                    const newVersion = buildMetaJSON.BuildInfo.applicationversion;
                    showModal(popupInfo, 'Nová verzia aplikácie je dostupná.',  () => {})
                    const data = {"version": newVersion}
                    api.post("/configuration/update_user_version/", data).then((response) => {
                        updateAppData({...appData, userVersionUpToDate: true})
                    })
                }
            }
        },[appData] // eslint-disable-line react-hooks/exhaustive-deps
    )

    return (
        <div className="status-bar">
            <Row>
                <Col>
                    <span>Verzia {getVersion()}</span>
                </Col>
                <Col>
                    <a style={{cursor: 'pointer'}} data-rr-ui-event-key="/users" className="nav-link" onClick={logout}>
                        <img className="logoutImage" src={logoutImage} alt="Odhlásiť"/>
                    </a>
                </Col>
            </Row>
        </div>
    )
}

export default StatusBar
